import React, { useEffect, useMemo, useState } from "react";
import InnerForm from "./Children/InnerForm";
import { Form, Formik } from "formik";
import {
  useCreateBusinessBox,
  useUpdatBusinessBox,
} from "../../services/mutations";
import {
  BBModalStyles,
  businessBoxInitialValues,
  businessBoxValidationSchema,
} from "./BusinessBoxHelpers";
import ToastMessage from "../../sharedcomponents/Toast";
import { TOAST_TYPE } from "../../utils/config";
import "./styles.css";
import { Box, Modal } from "@mui/material";

const CreateEditBusinessBox = ({
  showHeader,
  initialValues,
  refetch,
  open,
  onClose,
  setSelectedBoxCardData = () => {},
  handleFirstBbox = () => {},
  isFirstBbox = false,
}) => {
  const [apiLoading, setApiLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const createBusinessBox = useCreateBusinessBox();
  const updateBusinessBox = useUpdatBusinessBox();

  const isEdit = initialValues?.id;

  const onSubmitHandler = async (values, formikHelpers) => {
    formikHelpers.setSubmitting(true);
    setApiLoading(true);

    isEdit
      ? updateBusinessBox.mutate(values, {
          onSuccess: (response) => {
            setErrorMessage("");
            console.log("UPDATE SUCCESS:::", response);
            setApiLoading(false);
            onClose();
            formikHelpers.setSubmitting(false);
            refetch();
          },
          onError: (err) => {
            const error = err.response.data;
            const keys = Object.keys(error);
            keys.length && setErrorMessage(error[keys[0]]);
            setApiLoading(false);
            formikHelpers.setSubmitting(false);
          },
        })
      : createBusinessBox.mutate(values, {
          onSuccess: (response) => {
            setErrorMessage("");
            setApiLoading(false);
            onClose();
            // formikHelpers.resetForm({ values });
            formikHelpers.setSubmitting(false);
            // refetch();

            if (isFirstBbox) {
              handleFirstBbox(response.data);
            } else {
              refetch();
            }
          },
          onError: (err) => {
            const error = err.response.data;
            const keys = Object.keys(error);
            keys.length && setErrorMessage(error[keys[0]]);
            setApiLoading(false);
            formikHelpers.setSubmitting(false);
          },
        });
  };

  // useEffect(() => {
  //   if (!open) setSelectedBoxCardData(null);
  // }, [open]);

  return (
    <>
      {(createBusinessBox.isError || updateBusinessBox.isError) && (
        <ToastMessage
          message={
            errorMessage ? errorMessage : "Something went wrong, Try again !"
          }
          type={TOAST_TYPE.ERROR}
        />
      )}
      {(createBusinessBox.isSuccess || updateBusinessBox.isSuccess) && (
        <ToastMessage
          message={`Business Box has been ${isEdit ? "updated" : "created"}!`}
          type={TOAST_TYPE.SUCCESS}
        />
      )}
      <Modal
        open={open}
        onClose={onClose}
        BackdropProps={{
          style: {
            backgroundColor: "#F6F7F9",
            opacity: 0.8,
          },
        }}
        disableEscapeKeyDown
      >
        <Box sx={BBModalStyles}>
          <Formik
            initialValues={initialValues || businessBoxInitialValues}
            onSubmit={onSubmitHandler}
            enableReinitialize
            validateOnMount
            validationSchema={businessBoxValidationSchema}
          >
            {({ setFieldValue, values, isSubmitting }) => (
              <Form>
                <InnerForm
                  showHeader={showHeader}
                  apiLoading={apiLoading}
                  isEdit={isEdit}
                  onClose={onClose}
                />
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>
    </>
  );
};

export default CreateEditBusinessBox;
